import { render, staticRenderFns } from "./rolemanagetable.vue?vue&type=template&id=5ff3ebd2&scoped=true&"
import script from "./rolemanagetable.vue?vue&type=script&lang=js&"
export * from "./rolemanagetable.vue?vue&type=script&lang=js&"
import style0 from "./rolemanagetable.vue?vue&type=style&index=0&id=5ff3ebd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3ebd2",
  null
  
)

export default component.exports